import { Component, OnInit, ViewChild, } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Title } from '@angular/platform-browser';
import { welcomeDocs } from "../models/welcomeDocs";
import { CertificationService } from '../services/certification.service';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from "@angular/forms";
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { EmitType } from '@syncfusion/ej2-base';

@Component({
    selector: 'welcome',
    templateUrl: './welcome.component.html',
})
export class Welcomeomponent implements OnInit {

    hasLetterOfTransmittal: boolean = false;
    displayDialog: boolean = false;
    welcomeDocuments: welcomeDocs[];
    welcomeForm: UntypedFormGroup;
    welcomeTitle: string;
    getPrivacyDeclaration: boolean;
    showPrivacyPolicy: boolean = false;
    showFAQ: boolean;
    errorCollection: any = [];
    @ViewChild('showPrivacyPolicyDialog') showPrivacyPolicyDialog: DialogComponent;

    constructor(private router: Router, private title: Title, private certificationService: CertificationService, private fb: UntypedFormBuilder) {

        this.title.setTitle('Welcome to the Tax Certification Portal');

        this.certificationService.getWelcomePageContent()
            .subscribe((response: any) => {
                this.welcomeTitle = response.title;
                this.welcomeDocuments = response.welcomeDocuments;
                this.getPrivacyDeclaration = response.showPrivacy;
            });
    }

    ngOnInit() {
        this.welcomeForm = this.fb.group({
            'privacyAgree': new UntypedFormControl(false)
        });
        console.log(this.showPrivacyPolicy);
    }

    public onOpenPrivacyDialog(event: any): void {
        this.showPrivacyPolicy = true;
        console.log(this.showPrivacyPolicy);
        if (this.showPrivacyPolicyDialog) {
            this.showPrivacyPolicyDialog.show(); // Manually trigger show method
        }
    }

    /* Modal Dialogs --------------------------------------------------------------------------------------------------------------- */

    // The Dialog shows within the target element.
    public targetElement: HTMLElement;

    // Sets the Dialog to hidden on page load
    public visible: Boolean = false;

    // Shows the close icon
    public showCloseIcon: boolean = true;

    // Sample level code to hide the Dialog when click the Dialog overlay
    public onOverlayClick: EmitType<object> = () => {
        this.showPrivacyPolicyDialog2.hide();
    }

    @ViewChild('showPrivacyPolicyDialog2', { static: false }) public showPrivacyPolicyDialog2: DialogComponent;

    // Call the show method to open the Dialog
    public showPrivacyDialog2 = function (event: any): void {
        this.showPrivacyPolicyDialog2.show();
    }

    // Hide the Dialog when click the footer button.
    public hidePrivacyDialog2: EmitType<object> = () => {
        this.showPrivacyPolicyDialog2.hide();
    }

    submitWelcome() {

        this.displayDialog = false;

        if (!this.getPrivacyDeclaration || (this.welcomeForm.controls.privacyAgree != null && this.welcomeForm.controls.privacyAgree.value))
            this.router.navigate(['form/']);
        else
            this.errorCollection = { privacyAgree: ["To continue, you have to agree to the privacy policy by ticking the checkbox."] };
    }
}




